import ReportTransactionSelector from "components/Reports/ReportTransactionSelector";
import Table from "components/Table";
import useDateState from "helpers/useDateState";

export default function ReportTransactions() {
    const { fromDate, setDates, toDate } = useDateState();
    return (
        <div className="wrap-journal">
            {/* @ts-ignore */}
            <Table type="reportTransactions" MidComponent={ReportTransactionSelector} sumAmountInfo={[
                { name: "creditor", isCurrency: true },
                { name: "debtor", isCurrency: true },
            ]}
                getParamsBeforeFetch={(params) => {

                    return {
                        params: {
                            ...params,
                            column: fromDate ? "date" : undefined,
                            primarySearch: fromDate,
                            secondarySearch: toDate,
                            filterType: fromDate ? '7' : undefined
                        }
                    }
                }}
                disableDateFilter={true}
            />
        </div>
    );
}
